



















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BigNumber from 'bignumber.js';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import {
  deposit,
  withdraw,
  claim,
  userInfo,
  pendingWool,
  contractAddress,
} from '@/contract/woolRward';
import { balanceOf, increaseAllowance, allowance } from '@/utils/web3';
import { EventBus } from '@/utils/EventBus';

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class WoolStake extends Vue {
  public showStake: boolean = false;
  public tabs = ['StakeIn', 'StakeOut', 'Claim'];
  public curTab: string = 'StakeIn';
  public stakeIn: string = '0';
  public stakeOut: string = '0';
  public staked: BigNumber = new BigNumber(0);
  public earned: BigNumber = new BigNumber(0);
  public balanceOfAlpa: BigNumber = new BigNumber(0);
  public approveLoading: boolean = false;
  public allowanceAmount: BigNumber = new BigNumber(0);

  get account() {
    return this.$store.getters.getAccount;
  }

  get hasEarned() {
    return this.earned.isGreaterThan(0);
  }

  get showApprove() {
    if (this.allowanceAmount.isEqualTo(0)) {
      return true;
    }
    if (this.allowanceAmount.isGreaterThanOrEqualTo(this.stakeIn)) {
      return false;
    }
    return true;
  }

  get remaining() {
    return this.isBSC ? new BigNumber(10000).minus(this.staked) : new BigNumber(Number.MAX_VALUE);
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  get maximumStake() {
    return this.balanceOfAlpa.isLessThan(this.remaining) ? this.balanceOfAlpa : this.remaining;
  }

  public mounted() {
    EventBus.$on('approve-status', this.onApproveStatus);
  }

  public beforeDestroy() {
    EventBus.$off('approve-status', this.onApproveStatus);
  }

  public async getStaked() {
    const res = await userInfo(this.account);
    if (res) {
      this.staked = new BigNumber(res.amount);
    }
  }

  public async getEarned() {
    const amount = await pendingWool(this.account);
    if (amount) {
      this.earned = new BigNumber(amount);
    }
  }

  public async handleApprove() {
    if (!this.account) {
      return;
    }
    this.approveLoading = true;
    increaseAllowance(this.account, contractAddress!, 10000000);
  }

  public async getBalanceOfAlpa() {
    this.balanceOfAlpa = new BigNumber(await balanceOf(this.account));
  }

  public async getCurAllowance() {
    this.allowanceAmount = new BigNumber(await allowance(this.account, contractAddress!));
  }

  public async onApproveStatus(status: 'approving' | 'completed' | 'error') {
    if (status === 'completed') {
      await this.getCurAllowance();
      this.approveLoading = false;
    }
    if (status === 'error') {
      this.approveLoading = false;
    }
  }

  public handleDeposit() {
    deposit(this.stakeIn, this.account);
  }

  public handleWithdraw() {
    withdraw(this.stakeOut, this.account);
  }

  public handleClaim() {
    claim(this.account);
  }

  public maxStake(option: 'in' | 'out') {
    if (option === 'in') {
      this.stakeIn =
        this.balanceOfAlpa.isLessThan(this.remaining)
        ? this.balanceOfAlpa.toString()
        : this.remaining.toString();
    } else {
      this.stakeOut = this.staked.toString();
    }
  }

  public stakeInChange() {
    if (this.stakeIn === '') {
      return;
    } else if (new BigNumber(this.stakeIn).isLessThan(0)) {
      this.stakeIn = '0';
    } else if (new BigNumber(this.stakeIn).isGreaterThan(this.maximumStake)) {
      this.stakeIn = this.maximumStake.toString();
    }
  }

  public stakeOutChange() {
    if (this.stakeOut === '') {
      return;
    } else if (new BigNumber(this.stakeOut).isLessThan(0)) {
      this.stakeOut = '0';
    } else if (new BigNumber(this.stakeOut).isGreaterThan(this.staked)) {
      this.stakeOut = this.staked.toString();
    }
  }

  public toggleStake() {
    this.showStake = !this.showStake;
  }

  public isCurTab(tab: string) {
    return this.curTab === tab;
  }

  public changeTab(tab: string) {
    this.curTab = tab;
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getCurAllowance();
      this.getStaked();
      this.getEarned();
      this.getBalanceOfAlpa();
    }
  }
}
